<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Registratură Online - Direcția Generală de Urbanism și Amenajarea Teritoriului
            </h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <!-- Redirect botton for showing slug data in a separate page -->
    <!-- <button style="border-radius: 4px;padding: 4px 6px; color:red; margin: 3px 0; border:0; "
    (click)="redirectTo()">Redirect</button> -->
    <div class="content-box ">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă cereri</h3>
                        <div class="row">
                            <!-- <div class="col">
                                <button class="action-button">
                                <img src="/assets/icons/print-icon.svg" alt="Print" />
                                <span>Printați</span>
                                </button>
                            </div> -->
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                    (click)="rerenderDT(false)">
                                    <i class="fa-solid fa-arrows-rotate"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                    (click)="downloadManual()">
                                    <img src="assets/icons/icon-download.svg" alt="Descarcă" /> &nbsp;Manual
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">

                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <mat-button-toggle-group
                                *ngIf="permissionsService.hasPermission('urbanism-module.cerere.filtre-avansate')"
                                name="fontStyle" aria-label="Font Style" (change)="onFiltreChange($event)"
                                value="simple">
                                <mat-button-toggle value="simple">Filtre simple</mat-button-toggle>
                                <mat-button-toggle value="avansate">Filtre avansate</mat-button-toggle>
                            </mat-button-toggle-group>
                            <br />
                            <ng-container *ngIf="selectedFiltre === 'simple'">
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cerere</mat-label>
                                            <input matInput type="number" formControlName="numarCerere" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cerere (intern)</mat-label>
                                            <input matInput type="number" formControlName="numarCerereIntern" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>CNP/CIF</mat-label>
                                            <input matInput type="number" formControlName="cnp_cui" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Denumire Cetățean/PJ</mat-label>
                                            <input matInput type="text" formControlName="cetatean_pj" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Telefon</mat-label>
                                            <input matInput type="number" formControlName="telefon" />
                                        </mat-form-field>
                                    </div>

                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Email</mat-label>
                                            <input matInput type="text" formControlName="email" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr cadastral</mat-label>
                                            <input matInput type="number" pattern="[0-9]{6}"
                                                formControlName="numar_cadastral" />
                                            <mat-error *ngIf="searchParamsForm.get('numar_cadastral')?.invalid">
                                                Câmpul trebuie să conțină exact 6 cifre
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col">
                                        <strong class="m-0">Adresă imobil</strong>
                                        <mat-checkbox formControlName="check_adresa_proprietate"
                                            color="primary"></mat-checkbox>
                                    </div>
                                </div>

                                <div *ngIf="this.searchParamsForm.get('check_adresa_proprietate')?.value">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Strada</mat-label>
                                                <input matInput type="text" formControlName="proprietate_strada" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Număr</mat-label>
                                                <input matInput type="text" formControlName="proprietate_numar" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Scara</mat-label>
                                                <input matInput type="text" formControlName="proprietate_scara" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Bloc</mat-label>
                                                <input matInput type="text" formControlName="proprietate_bloc" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Etaj</mat-label>
                                                <input matInput type="text" formControlName="proprietate_etaj" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Apartament</mat-label>
                                                <input matInput type="text" formControlName="proprietate_apartament" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Observații</mat-label>
                                                <textarea type="text" matInput
                                                    formControlName="proprietate_observatii"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Adresă</mat-label>
                                            <mat-select formControlName="tip_adresa" [(value)]="selectedAddressType">
                                                <mat-option *ngFor="let option of address_type" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div
                                    *ngIf="selectedAddressType == '1' || selectedAddressType == '2' || selectedAddressType == '3'">
                                    <h3 *ngIf="selectedAddressType == '1'">Adăugați adresă domiciliu/reședință </h3>
                                    <h3 *ngIf="selectedAddressType == '2'">Adăugați adresă sediu </h3>
                                    <h3 *ngIf="selectedAddressType == '3'">Adăugați adresă beneficiar </h3>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Județ</mat-label>
                                                <mat-select matSelect formControlName="judet">
                                                    <mat-option *ngFor="let judet of judete" [value]="judet.id">
                                                        {{ judet.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Oraș</mat-label>
                                                <input matInput type="text" formControlName="city" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Strada</mat-label>
                                                <input matInput type="text" formControlName="streetName" />
                                            </mat-form-field>

                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Număr</mat-label>
                                                <input matInput type="number" formControlName="streetNumber" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="selectedFiltre === 'avansate'">
                                <h3 class="mb-1">Căutare după tip cerere</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment</mat-label>
                                            <mat-select formControlName="compartimentValue"
                                                (selectionChange)="onCompartimenteChange($event.value)">
                                                <mat-option *ngFor="let compartiment of compartimente"
                                                    [value]="compartiment.id">
                                                    {{ compartiment.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Cerere</mat-label>
                                            <mat-select formControlName="cerere_types">
                                                <mat-option value="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let cerere of requestTypes$ | async"
                                                    [value]="cerere.id">
                                                    {{ cerere.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după registre</h3>
                                <div class="row ">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Registru</mat-label>
                                            <mat-select formControlName="registru_types">
                                                <mat-option *ngFor="let registru of registre" [value]="registru.id">
                                                    {{ registru.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>


                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr registru</mat-label>
                                            <input matInput type="number" formControlName="numarRegistru" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după responsabil cerere</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Compartiment Responsabil</mat-label>
                                            <mat-select formControlName="compartimentResponsabil"
                                                (selectionChange)="onCompartimenteResponsabilChange($event.value)">
                                                <mat-option *ngFor="let compartiment of compartimenteResponsabil"
                                                    [value]="compartiment.id">
                                                    {{ compartiment.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Responsabil</mat-label>
                                            <mat-select formControlName="operator">
                                                <mat-option value="">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let operator of operatori$ | async"
                                                    [value]="operator.name">
                                                    {{ operator.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h3 class="mb-1">Căutare după operațiuni cerere</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Validat</mat-label>
                                            <mat-select formControlName="status_validat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Invalidat</mat-label>
                                            <mat-select formControlName="status_invalidat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Clasat</mat-label>
                                            <mat-select formControlName="status_clasat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Status Finalizat</mat-label>
                                            <mat-select formControlName="status_finalizat">
                                                <mat-option *ngFor="let option of parameters" [value]="option.value">
                                                    {{ option.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                            </ng-container>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                            <button class="action-button" (click)="toggleArhiva()"
                                [class.active-arhiva]="selectedArhivaID">
                                <span>Arhivă</span>
                            </button>
                            <span class="mx-2" *ngIf="filterCount > 0 && filterCount !== 1">{{filterCount}} filtre
                                aplicate</span>
                            <span class="mx-2" *ngIf="filterCount === 1">{{filterCount}} filtru aplicat</span>
                            <ng-container *ngIf="checkboxSelections">
                                <button *ngIf="permissionsService.hasPermission('urbanism-module.cerere.mass-assign')"
                                    class="action-button" (click)="openReassignComponent()">
                                    <span>Asignează</span>
                                </button>
                                <button *ngIf="permissionsService.hasPermission('urbanism-module.cerere.mass-update')"
                                    class="action-button" (click)="openChangeStatusComponent()">
                                    <span>Schimbare status</span>
                                </button>
                            </ng-container>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <mat-chip-listbox *ngIf="notificationParameter.name" aria-label="Notification selection">
                                <mat-chip-option>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <span style="margin-left: 3px;" (click)="removeChip()" aria-label="Remove">
                                            <mat-icon>cancel</mat-icon>
                                        </span>
                                    </div>
                                </mat-chip-option>
                            </mat-chip-listbox>
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <!-- <mat-form-field class="w-100">
                                                <mat-label>Filtrare după</mat-label>
                                                <mat-select [(ngModel)]="dateFilterOption">
                                                  <mat-option
                                                    *ngFor="let value of dateFilteringOptions"
                                                    [value]="value"
                                                  >
                                                    {{ value }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field> -->
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="request-filter-container">
                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusuriFiltered" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onCategoryChange($event)" [value]="selectedCategory">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>